import { waitForGlobal } from './waitForGlobal'
import { waitForLocalStorage } from './waitForLocalStorage'

declare global {
  interface Window {
    _6si?: any
  }
}

export const get6SenseGlobal = (signal?: AbortSignal) =>
  waitForGlobal(() => window._6si, { signal })

// https://support.6sense.com/docs/6sense-cookies-and-browser-storage#browser-storage-localstorage
const SIXSENSE_GUEST_DATA_KEY = '_6senseCompanyDetails'

export const deanonymizeWith6Sense = async (signal?: AbortSignal) => {
  await get6SenseGlobal(signal)
  const data = await waitForLocalStorage(SIXSENSE_GUEST_DATA_KEY, { signal })
  return {
    provider: '6Sense' as const,
    data,
  }
}

export type T6SenseDeanonymizationEvent = Awaited<ReturnType<typeof deanonymizeWith6Sense>>
